import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-vendor",
  "use": "icon-vendor-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-vendor\"><path d=\"M192.106667 948.586667m-73.152 0a3.429 3.429 0 1 0 146.304 0 3.429 3.429 0 1 0-146.304 0Z\" p-id=\"2582\" /><path d=\"M762.709333 948.586667m-73.152 0a3.429 3.429 0 1 0 146.304 0 3.429 3.429 0 1 0-146.304 0Z\" p-id=\"2583\" /><path d=\"M911.786667 68.8 842.986667 0l-98.24 98.261333 0.213333 0 0 632.768L210.304 731.029333 210.304 195.904l485.674667 0L695.978667 98.496 189.76 98.496C146.944 98.496 112.213333 130.965333 112.213333 173.781333l0 576.981333c0 42.794667 34.730667 77.546667 77.546667 77.546667l574.933333 0c42.816 0 77.525333-34.752 77.525333-77.546667L842.218667 138.389333 911.786667 68.8z\" p-id=\"2584\" /><path d=\"M258.858667 341.973333l437.141333 0 0 96.896-437.141333 0 0-96.896Z\" p-id=\"2585\" /><path d=\"M258.858667 536.576l437.141333 0 0 96.917333-437.141333 0 0-96.917333Z\" p-id=\"2586\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/vendor.svg
// module id = FmIy
// module chunks = 252